export default [
  {
    leistungstext: "Brand, Blitzschlag, Implosion, Explosion, Sturm, Hagel, Leitungswasser",
    infoText:
      "<strong>Brand</strong> – Feuer, das ohne bestimmungsgemäßen Herd (z. B. Kamin usw.) entstanden ist oder ihn verlassen hat und das sich aus eigener Kraft auszubreiten vermag.<br />" +
      "<strong>Blitzschlag</strong> – Unmittelbarer Übergang eines Blitzes auf Gebäude/Gegenstände.<br />" +
      "<strong>Explosion</strong> – Spontane Freisetzung großer Energiemengen auf kleinem Raum.<br />" +
      "<strong>Sturm</strong> – Wetterbedingtes &quot;Starkwindereignis&quot; von mindestens Windstärke 8 nach der Beaufortskala (Windgeschwindigkeit min. 62 km/h).<br />" +
      "<strong>Hagel</strong> – Fester Witterungsniederschlag in Form von Eiskörnern.<br />" +
      "<strong>Leitungswasser</strong> – &quot;Bestimmungswidrig&quot; ausgetretenes Wasser z. B. aus:" +
      "<ul><li>Rohren der Wasserversorgung (Zu- und Ableitungen),</li><li>Heizungs- oder Klimaanlagen,</li><li>Wasserlöschanlagen,</li><li>Wasserbetten oder Aquarien.</li></ul>",
    leistungen: ["Ja", "Ja", "Ja"],
  },
  {
    leistungstext: "Überspannungsschäden durch Blitz",
    infoText:
      "<strong>Überspannungsschäden</strong> - Schäden an elektrischen Einrichtungen oder Geräten durch Überspannung, Überstrom oder Kurzschluss, ausgelöst durch einen Blitzschlag.",
    leistungen: ["Ja", "Ja", "Ja"],
  },
  {
    leistungstext: "Einbruchdiebstahl, Beraubung, Vandalismus",
    infoText:
      "<strong>Einbruchdiebstahl</strong> – Besonders schwerer Fall des Diebstahls der durch gewaltsamen oder erschlichenen, in jedem Fall aber unbefugten, Zutritt in einen Raum erreicht wird. Dabei ist es z. B. unerheblich ob der Zutritt mit einem falschen oder richtigen Schlüssel geschah. Beides ist versichert.<br />" +
      "<strong>Raub</strong> – Gegen Sie als Person angewendete Gewalt, um gegen Ihren Widerstand an Ihre mitgeführten Sachen zu gelangen.<br />" +
      "<strong>Vandalismus</strong> – Die vorsätzliche Beschädigung oder Zerstörung von Hausrat nach Einbruch in die versicherte Wohnung.",
    leistungen: ["Ja", "Ja", "Ja"],
  },
  {
    leistungstext: "Außenversicherung",
    infoText:
      "<strong>Außenversicherung</strong> - Weltweiter Versicherungsschutz für versichertes Eigentum, dass sich (wie z. B. bei Urlaubsreisen) vorübergehend außerhalb des Versicherungsortes befindet.<br />" +
      "<u>Beispiel:</u> In Ihr Hotelzimmer oder Ferienhaus wird eingebrochen.",
    leistungen: ["3 Monate", "12 Monate", "24 Monate"],
  },
  {
    leistungstext: "Unbenannte Gefahren (SB 10 %, mind. 500 €, max. 5.000 €)",
    infoText:
      "Beschädigung, Zerstörung oder Abhandenkommen von versicherten Sachen durch ein unvorhergesehenes Ereignis werden entschädigt. Unvorhergesehen sind Schäden, die der Versicherungsnehmer oder ein Repräsentant weder rechtzeitig vorhergesehen haben noch mit der im Verkehr erforderlichen Sorgfalt hätten vorhersehen können.",
    leistungen: ["Nein", "Nein", "Ja"],
  },
  {
    leistungstext: "Steckersolaranlagen für Balkone (Balkonkraftwerke) bis 2 kWp",
    infoText: '"Balkonkraftwerke" und "Steckersolaranlagen" sind gegen die versicherten Gefahren mitversichert.',
    leistungen: ["Ja", "Ja", "Ja"],
  },
  {
    leistungstext: "Unterversicherungsverzicht bei Umzug in eine größere Wohnung",
    infoText:
      "Zieht der VN in eine größere Wohnung und meldet uns dies nicht, besteht der Unterversicherungsverzicht bis zur nächsten Hauptfälligkeit. Mit der Rechnung werden zeitgleich Änderungen angefragt",
    leistungen: ["3 Monate", "6 Monate", "12 Monate"],
  },
  {
    leistungstext: "Kein Einwand der groben Fahrlässigkeit bei Verletzung von Obliegenheiten / Sicherheitsvorschriften",
    infoText:
      "Kommt es zum Schaden, weil der VN gewissen Pflichten nicht nach gekommen ist (z.B. Installation und Wartung der Rückstauklappe), dann steht hierfür ein separater Versicherungsschutz zur Verfügung",
    leistungen: ["Nein", "Schäden bis 5.000 €", "Ja"],
  },
  {
    leistungstext: "Erweiterter Schutz bei grobfahrlässig herbeigeführten Schäden",
    infoText:
      "Grob fahrlässig handelt, wer es an der nötigen Umsichtigkeit und Sorgfalt fehlen lässt und in hohem Maß unbedacht und unvorsichtig agiert. Grobe Fahrlässigkeit kann beispielsweise vorliegen, wenn eine brennende Kerze über einen längeren Zeitraum unbeaufsichtigt bleibt oder eine Wohnungstür bei längerer Abwesenheit nur zugezogen und nicht verschlossen wird.",
    leistungen: ["Schäden bis 1.000 €", "Ja", "Ja"],
  },
  {
    leistungstext: "Konflikte mit Onlinehändlern",
    infoText:
      "<strong>Konflikte mit Onlinehändlern</strong> - Absicherung von Vermögensschäden, die Privatpersonen beim Onlinekauf entstehen können, wenn die bestellte Ware nicht geliefert wird.",
    leistungen: ["Nein", "Nein", "5.000 €"],
  },
  {
    leistungstext: "Konflikte als Onlinehändlern",
    infoText:
      "<strong>Konflikte mit Onlinehändlern</strong> - Absicherung von Vermögensschäden, die Privatpersonen beim Onlinekauf entstehen können, wenn für gelieferte Ware keine Zahlung geleistet wird.",
    leistungen: ["Nein", "Nein", "1.000 €"],
  },
  {
    leistungstext: "Verlust von aufgegebenem Gepäck",
    infoText: "Geht bei einer Reise in Verwahrung gegebenes Gepäck verloren erstatten wir hierfür die Kosten",
    leistungen: ["Nein", "Nein", "5.000 €"],
  },
  {
    leistungstext:
      "24 h-Schutz gegen Diebstahl von Fahrrädern, Fahrradanhängern, E-Bikes, Pedelecs (sofern nicht versicherungspflichtig) und deren Zubehör",
    infoText: "Fahrräder sind bis 1.000€ gegen Diebstahl bereits im Premium Tarif mitversichert.",
    leistungen: ["Nein", "Nein", "1.000 €"],
  },
  {
    leistungstext: "Wertsachen insgesamt",
    infoText:
      "<strong>Wertsachen</strong> sind z. B.:" +
      "<ul><li>Bargeld sowie Geldbeträge auf Karten oder sonstigen Datenträgern</li><li>Sparbücher und sonstige Wertpapiere</li><li>Schmucksachen, Edelsteine, Perlen, Urkunden, Briefmarken, Münzen</li><li>Pelze, handgeknüpfte Teppiche, Gobelins und Kunstgegenstände</li><li>Antiquitäten, die über 100 Jahre alt sind (mit Ausnahme von Möbelstücken)</li></ul>",
    berechnung: true,
    leistungen: ["30%", "40%", "50%"],
  },
  {
    leistungstext: "Schmucksachen, Edelsteine, Perlen, Briefmarken, Münzen etc. außerhalb von Wertschutzschränken ",
    infoText: "O.g. Gegenstände sind auch außerhalb von Tresoren, Wertschutzschränken und Safes versichert",
    leistungen: ["20.000 €", "40.000 €", "50.000 €"],
  },
  {
    leistungstext: "Best-Leistungs-Garantie",
    infoText:
      "<strong>Best-Leistungs-Garantie</strong> - Bietet ein anderer Versicherer am deutschen Markt einen besseren Versicherungsschutz, greift die Garantie und erweitert ohne Mehrkosten unseren vertraglichen Leistungsumfang.",
    leistungen: ["Nein", "Nein", "Ja"],
  },
  {
    leistungstext: "Summen- und Bedingungsdifferenzdeckung",
    infoText:
      "Sofern dieser Vertrag unmittelbar anschließend an eine bereits bestehende Hausratversicherung abgeschlossen wurde, ergänzt diese Differenzdeckung die anderweitig bestehende Hausratversicherung für dasselbe Risiko und dieselben Gefahren, bis zum Vertragsbeginn dieses Vertrages im nachstehend beschriebenen Umfang. Der Versicherungsschutz aus der anderweitig bestehenden Hausratversicherung geht dem Versicherungsschutz aus dem vorliegenden Vertrag vor.",
    leistungen: ["Nein", "Nein", "Ja bzw. aktivieren"],
  },
  {
    leistungstext: "Besitzstandsgarantie",
    infoText:
      "Stellt sich im Schadenfall heraus, dass der Versicherungsnehmer durch die Vertragsbedingungen zur Hausratversicherung des Vorvertrags beim vorherigen Versicherer in Bezug auf den Versicherungsumfang bessergestellt gewesen wäre, wird über die Besitzstandsgarantie gemäß des letzten Vertragsstandes des direkten Vorvertrags reguliert. Der Versicherungsnehmer hat in diesem Fall die Bedingungen des Vorversicherers zur Verfügung zu stellen.",
    leistungen: ["Nein", "Nein", "Ja"],
  },
];
